import { create } from "zustand";

import {
  nextSort,
  type ParticipantSort,
  type ParticipantSortKey,
} from "../lib/participants";

/**
 * Порядок строк в панели накопления — общий на всю вкладку.
 *
 * Стор, а не useState в панели, по той же причине, что у окна статистики и
 * режима «против нас»: панель живёт на странице рынка, рынки пятиминутные, и
 * оператор переходит с окна на окно десятки раз за сессию. Локальное состояние
 * сбрасывало бы порядок при каждом переходе, то есть «поставил по пнл» держалось
 * бы до конца окна — а вопрос, ради которого сортировку включают («кто здесь
 * самый убыточный», «кто больше всех взял у нас»), задают как раз на каждом
 * новом рынке.
 *
 * Без записи в localStorage — как и у соседних сторов: умолчание задаёт сервер
 * (выдача отсортирована по |нетто|), и сохранённая копия стала бы вторым местом,
 * где живёт порядок.
 *
 * `undefined` означает «порядок выдачи»: оператор не сортировал либо вернул
 * таблицу к исходному третьим щелчком.
 *
 * Ключ живёт здесь и вне режима «против нас», где соответствующих колонок на
 * экране нет вовсе. Это осознанно: сортировка по пустым числам ничего не
 * переставляет (sortLines устойчива), а возврат в режим восстанавливает порядок,
 * который оператор выбрал.
 */
interface ParticipantSortStore {
  sort: ParticipantSort | undefined;
  /** Щелчок по заголовку: вниз → вверх → обратно в порядок выдачи. */
  toggle: (key: ParticipantSortKey) => void;
}

export const useParticipantSort = create<ParticipantSortStore>((set) => ({
  sort: undefined,
  toggle: (key) => set((s) => ({ sort: nextSort(s.sort, key) })),
}));
